module.exports = __webpack_public_path__ + "img/product_share.3ebe0ad8.png";